import { useQuery } from "@tanstack/react-query";
import { Select } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { getAllServices } from "../../network/service";
import { service } from "../../types/service";

type Props = { services: any; setServices: any };

const SelectServiceSale = ({ services, setServices }: Props) => {
  const [searchValue, setSearchValue] = useState("");
  const { locationId } = useSelector((state: any) => state.calendar);
  const intl = useIntl();
  const { data } = useQuery(["services", searchValue], () =>
    getAllServices(locationId, searchValue)
  );
  const servicesOptions = Array.isArray(data?.data)
    ? data?.data
        ?.map((service: service) => {
          return service?.pricing_options?.map((option) => {
            if (
              services.find(
                (s: {
                  id: number;
                  service_id: number;
                  price: string;
                  duration: string;
                }) => s.id === option.id && s.service_id === option.service_id
              )
            ) {
              return {
                label: (
                  <div
                    className="flex justify-between p-1"
                    key={service?.id + " " + option?.id}
                  >
                    <p>{service?.name}</p>
                    <p>
                      {" "}
                      {option?.price}
                      <span className="mx-1 text-xs text-gray-500">
                        {intl.formatMessage({
                          id: "SAR",
                          defaultMessage: "ريال سعودي",
                        })}{" "}
                      </span>
                    </p>
                    <p>
                      {option?.duration}
                      <span className="mx-1 text-xs text-gray-500">
                        {intl.formatMessage({
                          id: "minutes",
                          defaultMessage: "دقيقة",
                        })}{" "}
                      </span>
                    </p>
                  </div>
                ),
                value: option?.id + " " + service?.id,
                key: option?.id + " " + service?.id,
                disabled: true,
              };
            } else {
              return {
                label: (
                  <div
                    className="flex justify-between p-1"
                    key={service?.id + " " + option?.id}
                  >
                    <p>{service?.name}</p>
                    <p>
                      {" "}
                      {option?.price}
                      <span className="mx-1 text-xs text-gray-500">
                        {intl.formatMessage({
                          id: "SAR",
                          defaultMessage: "ريال سعودي",
                        })}{" "}
                      </span>
                    </p>
                    <p>
                      {option?.duration}
                      <span className="mx-1 text-xs text-gray-500">
                        {intl.formatMessage({
                          id: "minutes",
                          defaultMessage: "دقيقة",
                        })}{" "}
                      </span>
                    </p>
                  </div>
                ),
                value: option?.id + " " + service?.id,
                key: option?.id + " " + service?.id,
              };
            }
          });
        })
        ?.flat()
    : [];

  const handleAddService = (value: string) => {
    const [id, service_id] = value.split(" ");
    const parentService: service = data?.data?.find(
      (service: service) => service.id === parseInt(service_id)
    );
    if (!parentService) return;
    const childService = parentService?.pricing_options?.find(
      (option) => option.id === parseInt(id)
    );
    if (!childService) return;

    const newServices: {
      id: number;
      name: string;
      service_id: number;
      price: string;
      duration: string;
    }[] = [
      ...services,
      {
        id: parseInt(id),
        name: parentService.name,
        service_id: childService?.service_id,
        price: childService.price,
        duration: childService.duration,
      },
    ];
    setServices(newServices);
  };
  return (
    <Select
      className="w-full"
      onSearch={(value) => {
        setSearchValue(value);
      }}
      onChange={(value) => {
        handleAddService(value);
        if (value && searchValue) {
          setSearchValue("");
        }
      }}
      showSearch
      placeholder={intl.formatMessage({
        id: "selectServices",
      })}
      filterOption={false}
      options={servicesOptions}
    />
  );
};

export default SelectServiceSale;
